import { Vehicle } from '../../../../../../common/types/Vehiculo'
import { normalizeMatriculaForDev } from './neumaticosDevConfig'

export interface NeumaticosDevScenario {
  id: string
  matricula: string
  descripcion: string
  pasos: string[]
}

/** Matrículas de prueba (formato válido). Ver consola al activar GATSBY_DEV_NEUMATICOS_MOCK. */
export const NEUMATICOS_DEV_SCENARIOS: NeumaticosDevScenario[] = [
  {
    id: 'ambiguo',
    matricula: '0860FFL',
    descripcion: 'Dos modelos por matrícula (reelegir, sin duplicar tarjeta)',
    pasos: [
      'Buscar 0860FFL → modal con 2 tarjetas CLASE B.',
      'Elegir uno → sidebar: 1 tarjeta + botón circular reelegir.',
      'Reelegir → vuelve la lista de 2 modelos.',
    ],
  },
  {
    id: 'unico',
    matricula: '4981KTN',
    descripcion: 'Un solo modelo (sin reelegir)',
    pasos: [
      'Buscar 4981KTN → un DACIA DUSTER.',
      'Tras elegir → sidebar con una tarjeta, sin icono reelegir.',
    ],
  },
  {
    id: 'guardado-dedup',
    matricula: '4317FPV',
    descripcion: 'Matrícula = vehículo guardado (sin duplicar UserVehiculoCard)',
    pasos: [
      'Con mock activo, área privada incluye 4317FPV.',
      'Buscar 4317FPV → solo tarjeta detallada de búsqueda.',
      'No debe aparecer 4317FPV otra vez en «O elige uno de tus vehículos».',
    ],
  },
  {
    id: 'guardados-lista',
    matricula: '0860FFL',
    descripcion: 'Varios vehículos guardados en fila (grid 15px)',
    pasos: [
      'Buscar 0860FFL → bloque inferior con 3333FDS y otros (no 4317FPV si no coincide).',
      'Comprobar alineación horizontal y fondo blanco.',
    ],
  },
  {
    id: 'elegir-guardado',
    matricula: '0860FFL',
    descripcion: 'Elegir vehículo guardado distinto del resultado API',
    pasos: [
      'Buscar 0860FFL → pulsar 3333FDS en guardados.',
      'Mobile: tarjeta compacta en sidebar; cerrar y reabrir modal → persiste.',
    ],
  },
  {
    id: 'filtro-taller',
    matricula: '7524MTR',
    descripcion: 'Varias medidas AMI; solo medida de taller (205/55 R16 91V)',
    pasos: [
      'Buscar 7524MTR → un SEAT LEÓN.',
      'Tras elegir modelo → GridLlantas con una sola medida (taller).',
      'Catálogo filtrado a esa medida.',
    ],
  },
  {
    id: 'sin-ic-iv',
    matricula: '2847NCI',
    descripcion: 'AMI sense IC/IV (només 205/55 R16 i 225/45 R17)',
    pasos: [
      'Buscar 2847NCI → un PEUGEOT 308.',
      'Tras elegir modelo → GridLlantas amb mides sense índex de càrrega ni velocitat.',
      'Comprovar que cal completar IC/IV manualment (tyres-with-values / selector).',
    ],
  },
]

function baseVehicle(
  partial: Pick<Vehicle, 'cod_matricula' | 'id_vehiculo'> &
    Partial<Vehicle>
): Vehicle {
  return {
    ano_fabric: 2006,
    ano_matric: 2006,
    mes_matric: '6',
    combustible_tipo: 'Gasolina',
    fecha_desde: '200506',
    id_marca: 47,
    id_modelo: 1001,
    marca: 'MERCEDES-BENZ',
    motor: '2.0i 136 [200]',
    potencia_cilindrada: 1998,
    potencia_cv: 136,
    potencia_kw: 100,
    cod_motor: 'M271',
    imagen: '',
    capacidad_carter: '',
    carroceria: '5P',
    id_vehiculo_ami: 555,
    id_vivid: 999,
    ...partial,
  }
}

const VEHICULOS_AMBIGUOS: Vehicle[] = [
  baseVehicle({
    cod_matricula: '0860FFL',
    id_vehiculo: 90101,
    modelo: 'CLASE B I (T245) FASE 1 - 5P 2005-06->2008-04',
    motor: '2.0i 136 [200]',
    potencia_cv: 136,
    id_vehiculo_ami: 5551,
    id_vivid: 9991,
  }),
  baseVehicle({
    cod_matricula: '0860FFL',
    id_vehiculo: 90102,
    modelo: 'CLASE B II (T245) FASE 2 - 5P 2008-05->2011-09',
    motor: '2.0 CDI 140 [204]',
    combustible_tipo: 'Gasóleo',
    potencia_cv: 140,
    id_vehiculo_ami: 5552,
    id_vivid: 9992,
  }),
]

const VEHICULO_UNICO: Vehicle[] = [
  baseVehicle({
    cod_matricula: '4981KTN',
    id_vehiculo: 90201,
    marca: 'DACIA',
    modelo: 'DUSTER (HM_)',
    combustible_tipo: 'Gasóleo',
    ano_matric: 2013,
    ano_fabric: 2013,
    motor: '1.5 dCi 110',
    potencia_cv: 110,
    id_vehiculo_ami: 5561,
    id_vivid: 9981,
  }),
]

const VEHICULO_GUARDADO_MATCH: Vehicle[] = [
  baseVehicle({
    cod_matricula: '4317FPV',
    id_vehiculo: 90301,
    marca: 'MERCEDES-BENZ',
    modelo: 'CLASE B (W245) SPORT 2005-2011',
    motor: '2.0i 136 [200]',
    potencia_cv: 136,
    id_vehiculo_ami: 5571,
    id_vivid: 9971,
  }),
]

const VEHICULO_FILTRO_TALLER: Vehicle[] = [
  baseVehicle({
    cod_matricula: '7524MTR',
    id_vehiculo: 90601,
    marca: 'SEAT',
    modelo: 'LEÓN (1P1)',
    motor: '1.4 TSI 125',
    potencia_cv: 125,
    id_vehiculo_ami: 5581,
    id_vivid: 9961,
  }),
]

const VEHICULO_SIN_IC_IV: Vehicle[] = [
  baseVehicle({
    cod_matricula: '2847NCI',
    id_vehiculo: 90701,
    marca: 'PEUGEOT',
    modelo: '308 (T9)',
    motor: '1.2 PureTech 130',
    potencia_cv: 130,
    ano_matric: 2018,
    ano_fabric: 2018,
    id_vehiculo_ami: 5591,
    id_vivid: 9951,
  }),
]

const MATRICULA_VEHICULOS: Record<string, Vehicle[]> = {
  '0860FFL': VEHICULOS_AMBIGUOS,
  '4981KTN': VEHICULO_UNICO,
  '4317FPV': VEHICULO_GUARDADO_MATCH,
  '7524MTR': VEHICULO_FILTRO_TALLER,
  '2847NCI': VEHICULO_SIN_IC_IV,
}

export function getDevVehiculosPorMatricula(
  matricula: string
): Vehicle[] | null {
  const key = normalizeMatriculaForDev(matricula)
  return MATRICULA_VEHICULOS[key] ?? null
}

export function logNeumaticosDevScenarios(): void {
  const rows = NEUMATICOS_DEV_SCENARIOS.map(
    (s) => `  • ${s.matricula} — ${s.descripcion}`
  ).join('\n')
  // eslint-disable-next-line no-console
  console.info(
    `[MKB-1010/1011] Neumáticos DEV mock activo. Matrículas de prueba:\n${rows}\nDetalle: vehiculoMockFixtures.ts`
  )
}
